// Module
var code = `<custom-fee-list form="\$ctrl.form"
                 fee-definitions="\$ctrl.feeDefinitions"
                 product-group="'LOAN'"
                 on-change="\$ctrl.onSave()"
                 product-config="{loanInterestType: \$ctrl.loanProduct.interestType,
                                  amortizationType: \$ctrl.loanProduct.amortizationType}">
</custom-fee-list>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/details/forms/loan-product-charges.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;